import Routes from "./Routes/Routes";

const App = () => {
	return (
		<div className="App">
			<Routes />
		</div>
	);
};

export default App;
